export default "__VITE_ASSET__b9734a03__"